import React from 'react';

/**
 * THE hover card — one presentational component for every summary the site
 * raises over a link (issue 73, generalized from the condition-term card of
 * issue 36 rather than built a second time, so there is one card to keep
 * visually consistent and accessible across the four themes).
 *
 * It renders a name, an optional sentence, an optional label/value grid and an
 * optional hint. Nothing in it is interactive and nothing in it is the only
 * route to the information: every card sits over a real link to the entry, so
 * a reader with no pointer, no hover or no JavaScript still gets there. It is
 * `pointer-events: none` for the same reason — it must never sit between the
 * cursor and the link it describes.
 *
 * Colour comes from the theme tokens only, and colour is never the only
 * signal: a row's label is text, not a hue.
 */
export default function HoverCard({ name, text, rows, hint, className, style, id }) {
  return (
    <div id={id} role="tooltip" className={`hover-card${className ? ` ${className}` : ''}`} style={style}>
      <strong className="hover-card__name">{name}</strong>
      {text && <span className="hover-card__text">{text}</span>}
      {rows && rows.length > 0 && (
        <dl className="hover-card__rows">
          {rows.map((row, i) => (
            <React.Fragment key={`${row.label}-${i}`}>
              <dt>{row.label}</dt>
              <dd>{row.text}</dd>
            </React.Fragment>
          ))}
        </dl>
      )}
      {hint && <span className="hover-card__hint">{hint}</span>}
    </div>
  );
}
